// extracted by mini-css-extract-plugin
module.exports = {"header-image":"_Layout_header-image_H1VbS","layout-size":"_Layout_layout-size_1tU3k","layout-color":"_Layout_layout-color_2tEyS","terms":"_Layout_terms_PKHQl"};